import { render, staticRenderFns } from "./MultiRights.vue?vue&type=template&id=495cdf9b"
import script from "./MultiRights.vue?vue&type=script&lang=js"
export * from "./MultiRights.vue?vue&type=script&lang=js"
import style0 from "./MultiRights.vue?vue&type=style&index=0&id=495cdf9b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports